import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NotificationsService } from './notifications.service';

import { IAppState } from '../app.state';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  notifications: Observable<any> = this.store.select('notifications');

  constructor(
    private notificationsService: NotificationsService,
    private store: Store<IAppState>,
  ) {}

  ngOnInit() {
    this.notificationsService.populate().subscribe();
    this.notificationsService.setNotificationsAsSeen().subscribe();
  }
}
